import type {CustomerProfileTabContext} from "~/components/entityProfile/profileTabRegistry";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";
import {ProfileLifecycleTabView} from "~/components/entityProfile/lifecycle/profileLifecycleTabView";

export function ProfileLifecycleTabContent({
    tabRenderProps,
    context,
}: {
    tabRenderProps: ProfileTabRenderProps;
    context: CustomerProfileTabContext;
}) {
    if (tabRenderProps.kind !== "customer") {
        return null;
    }

    return <ProfileLifecycleTabView lifecycle={context.lifecycle} />;
}
